export default __webpack_public_path__ + "static/media/supply-chain.6dd55a0f.png";